import { render } from "./IconRecipientsPending.vue?vue&type=template&id=b88c772a"
import script from "./IconRecipientsPending.vue?vue&type=script&lang=js"
export * from "./IconRecipientsPending.vue?vue&type=script&lang=js"
script.render = render

export default script